<div class="row">
  <div class="col-12">
    <mat-card>
      <sm-back-title-bar
        pageSubTitle="Subscription information"
        [showBackButton]="true"
      ></sm-back-title-bar>
      <div class="rounded-3 bg-light">
        <sm-data-table
          [columnHeaders]="tableColumns"
          [dataSource]="businessInfoList"
          [showFilter]="true"
          [showPagination]="true"
          [itemsPerPage]="5"
        >
          <ng-template #dateTemplate let-rowVal="row" let-colVal="col">
            {{ rowVal[colVal.columnProperty] | date: "MMM d, y, h:mm a" }}
          </ng-template>
        </sm-data-table>
      </div>
    </mat-card>
  </div>
</div>
